import React, { PureComponent } from 'react';

import withSlide from '~/kits/general/scripts/components/withSlide';
import ComparisonMap from '~/kits/general/scripts/components/ComparisonMap';
import { getColorScale } from '~/kits/general/scripts/components/ComparisonMap/utils';
import { getMapDataByKey, getDonutDataByKey } from '~/kits/general/scripts/data-utils';

const colorScale = getColorScale([
  [0, '#ffbcd3'],
  [9, '#e393aa'],
  [18, '#c66b83'],
  [27, '#a8445e'],
  [36, '#89143b']
]);

const mapData = getMapDataByKey('com');
const donutData = getDonutDataByKey('com', '#96276E');
const maxLegendValue = 36;

class LeftMap extends PureComponent {
  render() {
    const { title, text, isActive } = this.props;

    return (
      <ComparisonMap
        title={title}
        text={text}
        isActive={isActive}
        mapData={mapData}
        colorScale={colorScale}
        donutData={donutData}
        maxLegendValue={maxLegendValue}
      />
    );
  }
}

export default withSlide(LeftMap);
